var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      style: _vm.css,
      attrs: {
        multiple: "",
        filterable: "",
        remote: "",
        "value-key": "id",
        "remote-method": _vm.loadTicketUserList,
        placeholder: "输入名字或账号搜索"
      },
      on: { change: _vm.onChange, "visible-change": _vm.onVisibleChange },
      model: {
        value: _vm.valueData,
        callback: function($$v) {
          _vm.valueData = $$v
        },
        expression: "valueData"
      }
    },
    _vm._l(_vm.ticketUserOptionList, function(item) {
      return _c("el-option", {
        key: item.id,
        attrs: { label: item.label, value: item }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-446c962e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-446c962e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/NoticeUserSearch.vue
// module id = 748
// module chunks = 75